import { render, staticRenderFns } from "./BeginApplication.vue?vue&type=template&id=63b5fe93&"
import script from "./BeginApplication.vue?vue&type=script&lang=ts&setup=true&"
export * from "./BeginApplication.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./BeginApplication.vue?vue&type=style&index=0&id=63b5fe93&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports